import {PlanDetails} from "./PlanDetails";
import {InsuredDetails} from "./InsuredDetails";
import {OwnerDetails} from "./OwnerDetails";
import {Beneficiary} from "./Beneficiary";
import {PendingPolicy} from "./PendingPolicy";
import {InforcePolicy} from "./InforcePolicy";

export class UpdateApplicationRequest {
    insuredDetails: InsuredDetails;
    ownerDetails: OwnerDetails;
    // primaryBeneficiary: Beneficiary;
    // contingentBeneficiary: Beneficiary;
    //applicationDataComments: string;
    applicationId: string;
    beneficiaries: Beneficiary[] = [];
    pendingPolicies: PendingPolicy[] = [];
    inforcePolicies: InforcePolicy[] = [];
    constructor() {
        this.insuredDetails = new InsuredDetails();
        this.ownerDetails = new OwnerDetails();
        // this.primaryBeneficiary = new Beneficiary();
        // this.contingentBeneficiary = new Beneficiary();
        //this.applicationDataComments = '';
        this.applicationId = '';
    }
}
